export var ProductType;
(function (ProductType) {
    ProductType["DIGITAL"] = "digital";
    ProductType["PHYSICAL"] = "physical";
})(ProductType || (ProductType = {}));
export var MediaFrameMediaType;
(function (MediaFrameMediaType) {
    MediaFrameMediaType["SECURE_PICTURE"] = "secure_picture";
    MediaFrameMediaType["SECURE_VIDEO"] = "secure_video";
    MediaFrameMediaType["SECURE_DOCUMENT"] = "secure_document";
    MediaFrameMediaType["SECURE_MUSIC"] = "secure_music";
    MediaFrameMediaType["SECURE_ARCHIVE"] = "secure_archive";
})(MediaFrameMediaType || (MediaFrameMediaType = {}));
export var FilterType;
(function (FilterType) {
    FilterType["COLLECTION"] = "COLLECTION";
    FilterType["CUSTOM_COLLECTION"] = "CUSTOM_COLLECTION";
    FilterType["PRICE"] = "PRICE ";
    FilterType["COLOR_OPTION"] = "COLOR_OPTION";
    FilterType["LIST_OPTION"] = "LIST_OPTION";
})(FilterType || (FilterType = {}));
export var FilterTypeFromFetch;
(function (FilterTypeFromFetch) {
    FilterTypeFromFetch["CATEGORY"] = "CATEGORY";
    FilterTypeFromFetch["FILTERED_CATEGORIES"] = "FILTERED_CATEGORIES";
    FilterTypeFromFetch["PRICE"] = "PRICE";
    FilterTypeFromFetch["COLOR"] = "OPTION_COLOR";
    FilterTypeFromFetch["LIST"] = "OPTION_LIST";
})(FilterTypeFromFetch || (FilterTypeFromFetch = {}));
export var FilterTypeForFetch;
(function (FilterTypeForFetch) {
    FilterTypeForFetch["CATEGORY"] = "CATEGORY";
    FilterTypeForFetch["FILTERED_CATEGORIES"] = "FILTERED_CATEGORIES";
    FilterTypeForFetch["OPTIONS"] = "OPTIONS";
    FilterTypeForFetch["PRICE"] = "PRICE";
})(FilterTypeForFetch || (FilterTypeForFetch = {}));
export var FilterConfigType;
(function (FilterConfigType) {
    FilterConfigType["CATEGORY"] = "CATEGORY";
    FilterConfigType["PRICE"] = "PRICE";
    FilterConfigType["OPTIONS"] = "OPTIONS";
    FilterConfigType["OPTION_LIST"] = "OPTION_LIST";
})(FilterConfigType || (FilterConfigType = {}));
export var FilterEqOperation;
(function (FilterEqOperation) {
    FilterEqOperation["EQUALS"] = "EQUALS";
    FilterEqOperation["GTE"] = "GTE";
    FilterEqOperation["LTE"] = "LTE";
    FilterEqOperation["BETWEEN"] = "BETWEEN";
    FilterEqOperation["IN"] = "IN";
    FilterEqOperation["IN_ALL"] = "IN_ALL";
})(FilterEqOperation || (FilterEqOperation = {}));
export var ImageModeId;
(function (ImageModeId) {
    ImageModeId[ImageModeId["Crop"] = 1] = "Crop";
    ImageModeId[ImageModeId["Fit"] = 2] = "Fit";
})(ImageModeId || (ImageModeId = {}));
export var HoverType;
(function (HoverType) {
    HoverType["None"] = "none";
    HoverType["Zoom"] = "zoom";
    HoverType["Border"] = "border";
    HoverType["Alternate"] = "alternate";
})(HoverType || (HoverType = {}));
export var ImageRatioId;
(function (ImageRatioId) {
    ImageRatioId[ImageRatioId["_3x2"] = 0] = "_3x2";
    ImageRatioId[ImageRatioId["_4x3"] = 1] = "_4x3";
    ImageRatioId[ImageRatioId["_1x1"] = 2] = "_1x1";
    ImageRatioId[ImageRatioId["_3x4"] = 3] = "_3x4";
    ImageRatioId[ImageRatioId["_2x3"] = 4] = "_2x3";
    ImageRatioId[ImageRatioId["_16x9"] = 5] = "_16x9";
    ImageRatioId[ImageRatioId["_9x16"] = 6] = "_9x16";
})(ImageRatioId || (ImageRatioId = {}));
export var PaginationType;
(function (PaginationType) {
    PaginationType[PaginationType["PAGES"] = 1] = "PAGES";
    PaginationType[PaginationType["COMPACT"] = 2] = "COMPACT";
})(PaginationType || (PaginationType = {}));
export var LoadMoreType;
(function (LoadMoreType) {
    LoadMoreType[LoadMoreType["BUTTON"] = 1] = "BUTTON";
    LoadMoreType[LoadMoreType["PAGINATION"] = 2] = "PAGINATION";
    LoadMoreType[LoadMoreType["INFINITE"] = 3] = "INFINITE";
})(LoadMoreType || (LoadMoreType = {}));
export var ContentJustification;
(function (ContentJustification) {
    ContentJustification["START"] = "start";
    ContentJustification["CENTER"] = "center";
    ContentJustification["END"] = "end";
})(ContentJustification || (ContentJustification = {}));
export var GridType;
(function (GridType) {
    GridType[GridType["MANUAL"] = 1] = "MANUAL";
    GridType[GridType["AUTO"] = 2] = "AUTO";
})(GridType || (GridType = {}));
//# sourceMappingURL=galleryTypes.js.map